import { render } from "./suspendedModal.vue?vue&type=template&id=98fea1fa"
import script from "./suspendedModal.vue?vue&type=script&lang=js"
export * from "./suspendedModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__